import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../../services';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { FailedMessagesEndpoint } from '../../constants/failed-messages-endpoint';
import { Observable } from 'rxjs';
import { FailedMessagesProfileItemFilterModel } from '../../models/profile/failed-messages-profile-item.model';

@Injectable({
  providedIn: 'root',
})
export class FailedMessagesProfileItemService {
  constructor(private http: WrapperHttpService) {}

  getProfile(id: number): Observable<FailedMessagesProfileItemFilterModel> {
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Profiles}/${id}`;
    return this.http.withLoading().get<FailedMessagesProfileItemFilterModel>(url);
  }

  createProfile(body: Partial<FailedMessagesProfileItemFilterModel>): Observable<FailedMessagesProfileItemFilterModel> {
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Profiles}`;
    return this.http.withLoading().post<FailedMessagesProfileItemFilterModel>(url, body);
  }

  updateProfile(body: Partial<FailedMessagesProfileItemFilterModel>): Observable<FailedMessagesProfileItemFilterModel> {
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Profiles}`;
    return this.http.withLoading().post<FailedMessagesProfileItemFilterModel>(url, body);
  }
}
